import backendApi from "@/api/backendApi";
import loading from "./loading";

const state = {
    officesData: [],
    countriesData: [],
};

const actions = {
    getOffices({commit}) {

        commit('loading');

        backendApi.requestApi('GET', 'reference/offices')
            .then(
                response => {
                    if(response.status){
                        commit('Offices', response.data);
                    }
                    commit('stopLoading');
                },
                () => {
                    commit('stopLoading');
                }
            );
    },
    getCountries({commit}) {

        commit('loading');

        backendApi.requestApi('GET', 'reference/countries')
            .then(
                response => {
                    if(response.status){
                        commit('Countries', response.data);
                    }
                    commit('stopLoading');
                },
                () => {
                    commit('stopLoading');
                }
            );
    }
};

const getters = {
    offices: state => {
        return state.officesData ? state.officesData : null;
    },
    countries: state => {
        return state.countriesData ? state.countriesData : null;
    },
}

const mutations = {
    loading(){
        loading.state.status = true;
    },
    stopLoading(){
        loading.state.status = false;
    },
    Offices(state, data) {
        if(!Array.isArray(data)){
            return;
        }
        let offices = [];
        data.forEach(function(office) {
            offices.push({name: office.name, code: office.code, full_name: office.code + " - " + office.name});
        });
        state.officesData = offices;
    },
    Countries(state, data) {
        state.countriesData = data;
    }
};

export default {
    namespaced: true,
    state,
    actions,
    getters,
    mutations
};